// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectEntitiesMatchesEntity,
  selectEntitiesMatchesEntityPeriodId,
  selectEntitiesMatchesEntitySportId,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { type StateType } from '../../states';
import { MatchEntity } from '../../states/entities/matches';
import PeriodIds from '../../types/periodIds';
import { SportIds } from '../../types/sports';
import { extractMatchClock } from '../../utils/entity';

const SportsWithHalfTime = [SportIds.SOCCER, SportIds.HANDBALL, SportIds.RUGBY, SportIds.RUGBY_LEAGUE];

type SelectorProps = {
  matchId?: number;
  showPeriod?: boolean;
};

const getShowPeriodFromProps = (state: StateType, { showPeriod }: SelectorProps) => showPeriod;

const makeMatchTimerPropsSelector = () => {
  const selectMatchClockExtract = createSelector(selectEntitiesMatchesEntity, (match) =>
    match ? extractMatchClock(match) : null,
  );

  const selectType = createSelector([selectMatchClockExtract], (matchClockExtract) => matchClockExtract?.type);

  const selectTime = createSelector([selectMatchClockExtract], (matchClockExtract) => matchClockExtract?.time);

  const selectSeconds = createSelector([selectMatchClockExtract], (matchClockExtract) => matchClockExtract?.seconds);

  const selectIsAdditionalTime = createSelector(
    [selectMatchClockExtract],
    (matchClockExtract) => matchClockExtract?.isAdditionalTime,
  );

  const selectShowOnlyMinutes = createSelector(
    [selectMatchClockExtract],
    (matchClockExtract) => matchClockExtract?.showOnlyMinutes,
  );

  const selectShowPeriod = createSelector(
    [selectEntitiesMatchesEntitySportId, selectEntitiesMatchesEntityPeriodId, getShowPeriodFromProps],
    (sportId, periodId, showPeriodIdFromProps) =>
      showPeriodIdFromProps ||
      (SportsWithHalfTime.indexOf(Number(sportId)) !== -1 && periodId === PeriodIds.PERIOD_ID_SOCCER_HALF_TIME),
  );

  const selectShow = createSelector(
    [selectEntitiesMatchesEntity, selectMatchClockExtract, selectType, selectSeconds],
    (match, clockExtract, type, seconds) =>
      match && !MatchEntity.isEnded(match) && !!clockExtract && type !== undefined && seconds !== undefined,
  );

  return createSelector(
    [
      selectType,
      selectTime,
      selectSeconds,
      selectIsAdditionalTime,
      selectShowOnlyMinutes,
      selectEntitiesMatchesEntityPeriodId,
      selectShowPeriod,
      selectShow,
    ],
    (type, time, seconds, isAdditionalTime, showOnlyMinutes, periodId, showPeriod, show) => ({
      type,
      time,
      seconds,
      isAdditionalTime,
      showOnlyMinutes,
      periodId,
      showPeriod,
      show,
    }),
  );
};

export default makeMatchTimerPropsSelector;
